import { Common } from '@stockbit/ui';
import dynamic from 'next/dynamic';

import { useNotificationData } from 'lib/entities/notification/useNotificationData';

import IconNotification from './NotificationIcon';
import NotificationHeader from './NotificationHeader';
import { CustomPopoverContainer, PopoverContentMobile } from './styled';
import NotificationFooter from './NotificationFooter';
import NotificationList from './NotificationList';

const StreamConversation = dynamic(() => import('global/StreamConversation'), {
  ssr: false,
});

const { Popover } = Common;

const NotificationMobile = () => {
  const unread = useNotificationData((store) => store.unread);
  const isConvoOpen = useNotificationData((store) => store.isConvoOpen);
  const isPopupOpen = useNotificationData((store) => store.isPopupOpen);
  const convoId = useNotificationData((store) => store.convoId);
  const togglePopup = useNotificationData((store) => store.togglePopup);
  const setConvoOpen = useNotificationData((store) => store.setConvoOpen);

  return (
    <>
      <Popover
        trigger="click"
        visible={isPopupOpen}
        onVisibleChange={togglePopup}
        getPopupContainer={(trigger) => trigger.parentElement}
        content={() => (
          <CustomPopoverContainer>
            <NotificationHeader device="mobile" />
            <PopoverContentMobile>
              <NotificationList />
            </PopoverContentMobile>
            <NotificationFooter />
          </CustomPopoverContainer>
        )}
      >
        <IconNotification
          count={unread}
          data-cy="top-navbar-icon-notification-mobile"
        />
      </Popover>
      {isConvoOpen && (
        <StreamConversation
          postId={convoId}
          visible={isConvoOpen}
          activeCommentId={convoId}
          onCancel={() => setConvoOpen(undefined, false)}
        />
      )}
    </>
  );
};

export default NotificationMobile;
